<form class="popupForm" style="min-height: 200px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span *ngIf="action_type === 'approve_as_friends'">{{'approve_as_friends_popup_title' | GetLabelPipe}}</span>
      <span *ngIf="action_type === 'remove_from_friends'">{{'remove_from_friends_popup_title' | GetLabelPipe}}</span>
      <span *ngIf="action_type === 'wait_friend_approval'">{{'wait_friend_approval_popup_title' | GetLabelPipe}}</span>
      <span *ngIf="action_type === 'approve_in_class'">{{'approve_in_class_popup_title' | GetLabelPipe}}</span>
      <span *ngIf="action_type === 'remove_from_class'">{{'remove_from_class_popup_title' | GetLabelPipe}}</span>
      <span *ngIf="action_type === 'mutual_class'">{{'mutual_class_popup_title' | GetLabelPipe}}</span>
      <span *ngIf="action_type === 'my_referral'">{{'your_referral_title' | GetLabelPipe}}</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important;">
      <div *ngIf="action_type === 'approve_as_friends'">{{'approve_as_friends_popup_description' | GetLabelPipe}} "{{item['itemFullData']['shipping_name']}}"</div>
      <div *ngIf="action_type === 'remove_from_friends'">{{'remove_from_friends_popup_description' | GetLabelPipe}} "{{item['itemFullData']['shipping_name']}}"</div>
      <div *ngIf="action_type === 'wait_friend_approval'">{{'wait_friend_approval_popup_description' | GetLabelPipe}}</div>
      <div *ngIf="action_type === 'approve_in_class'">{{'approve_in_class_popup_description' | GetLabelPipe}} "{{item['itemFullData']['relation_params']['__class']['name']}}"</div>
      <div *ngIf="action_type === 'remove_from_class'">{{'remove_from_class_popup_description' | GetLabelPipe}} "{{item['itemFullData']['relation_params']['__class']['name']}}"</div>
      <div *ngIf="action_type === 'mutual_class'">{{'mutual_class_popup_description' | GetLabelPipe}}</div>
      <div *ngIf="action_type === 'my_referral'">{{'your_referral_description' | GetLabelPipe}}</div>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'close' | GetLabelPipe}}
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent"
              *ngIf="['wait_friend_approval','mutual_class','my_referral'].indexOf(action_type) === -1"
              (click)="handleSubmit()">
        {{'confirm' | GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
